import { AvailableChildrenType, SugarElementInfo } from "../../SugarElementInfo";

import { commonContentAttributes } from "./commonContentAttributes";

export const perfedzelpr: SugarElementInfo = {
    name: "perfedzelpr",
    availableChildren: { type: AvailableChildrenType.Any },
    attributes: commonContentAttributes,
};
